module.exports = __webpack_public_path__ + "static/media/amsterdam.85e0fd06.jpg";